import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip, Modal } from 'antd';
import { intialPaginationState, showingPageTotalRange, filter } from '../../../common_functions';

const Parks = props => {
  const [locations, setLocations] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'State',
      dataIndex: 'state.state',
      key: 'state.state',
      sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{record.state.state}</span>,
      ...filter('state.state'),
    },
    {
      title: 'Park',
      dataIndex: 'park',
      key: 'park',
      sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{text}</span>,
      ...filter('park'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/parks/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_parks?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_parks?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'parks',
              'Park?',
              locations,
              setLocations,
              props?.tabs_permissions?.settings_parks?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getLocationsData(pagination);
  })();
  }, []);

  const getLocationsData = async (pagination, filters = {}, sorter = '') => {
    try {
      setLoading(true);
      const response = await props.getItems('parks', {
        fields: ['id', 'state.id', 'state.state', 'park'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setLocations(response.data);
    } catch (error) {
      Modal.warning({
        title: 'Error',
        content: 'Unexpected error occured',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (!!val) {
          if (key == 'id') {
            filtersitems[key] = { _eq: val[0] };
          } else if (key == 'state.state') {
            filtersitems['state'] = { state: { _icontains: val[0] } };
          } else {
            filtersitems[key] = { _icontains: val[0] };
          }
        }
      }
    }
    await getLocationsData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/parks" }, { title: "Parks" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Parks
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(props.roleType, props.tabs_permissions.settings_parks, `/settings/parks/new`, 'Create Park')}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={locations}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Parks;
